module.exports = __webpack_public_path__ + "static/media/right-cat-arrow.76384756.svg";